export const colors = {
  base: {
    level10: '#FFFFFF',
    level20: '#FAFAFA',
    level30: '#EFEFF1',
    level40: '#E4E4E7',
    level50: '#A1A1AA',
    level60: '#71717A',
    level70: '#18181B',
    white: '#FFFFFF',
  },
  gray: {
    50: '#FAFAFA',
    100: '#F5F5F5',
    200: '#E5E5E5',
    300: '#D4D4D4',
    500: '#737373',
    600: '#525252',
    900: '#171717',
  },
  amethyst: {
    level50: '#8B5CF6',
  },
  emerald: {
    level10: '#ECFDF5',
    level50: '#10B981',
    level60: '#059669',
  },
  mono: {
    level4_400: '#A1A1AA',
    level7_900: '#18181B',
  },
  red: {
    50: '#FEF2F2',
    100: '#D33751',
    500: '#EF4444',
  },
  pink: {
    500: '#C62B66',
  },
  ruby: {
    level10: '#FEF2F2',
    level50: '#EF4444',
    level60: '#DC2626',
  },
  specific: {
    buttonBg: `linear-gradient(267deg, #C62B66 1.25%, #D33751 98.75%)`, //red100 and pink500
  },
  link: '#0C66E4',
  blue: {
    level10: '#EFF6FF',
    level60: '#2563EB',
  },
  topaz: {
    level50: '#3B82F6',
  },
  amber: {
    level50: '#F59E0B',
  },
  primary: {
    main: '#CB315B',
    light: '#E17392',
    dark: '#AA2C4E',
  },
  background: {
    base: '#fcfcfd',
  },
};
